import React, { useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Script, ScriptStrategy } from "gatsby";

import { useSiteMetadata } from "../hooks/useSiteMetadata";

const ShareButtons = ({ className }) => {
    const { shareThisKey } = useSiteMetadata();

    useEffect(() => {
        if (window?.st) {
            window.st.initialize();
        }
    }, []);

    return (
        <>
            <div
                className={classNames(
                    "sharethis-inline-share-buttons my-3",
                    className
                )}
            />
            {shareThisKey && (
                <Script
                    type="text/javascript"
                    src={`https://platform-api.sharethis.com/js/sharethis.js#property=${shareThisKey}&product=inline-share-buttons`}
                    strategy={ScriptStrategy.idle}
                />
            )}
        </>
    );
};

ShareButtons.propTypes = {
    className: PropTypes.string,
};

export default ShareButtons;
